/**
 * Service: loggerApi
 */
angular.module('acme.common.service.loggerApi', [
  'acme.common.factory.apiVersion',
  'acme.common.factory.QueryStringBuilder'
])
.service('LoggerApiService', ['$http', 'ApiVersionFactory', 'QueryStringBuilderFactory', function($http, ApiVersionFactory, QueryStringBuilderFactory) {

    return {

      service: '',

      init: function(endpoint) {
        this.service = endpoint + '/logger';
        return this;
      },

      log: function(props) {

        var av = new ApiVersionFactory();


        if (props) {
          var qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              optional: ['sendEmail']
            }
          });
          q = qs.query;
        }

        return $http({
          method: 'post',
          url: av.init({url: (this.service + '/log' + q), version: 'v2'}),
          data: props
        });

      }

    };

}]);